import { useSupabaseCallback } from "../../../server/supabase/hooks";
import { SupabasePollService } from "../server/supabase-poll-service";

import type { UUID } from "../../../utils/uuid";
import type { PollWithOptions } from "../server/supabase-poll-service";

export function useGetPollsWithOptions(): (
  poll_ids: UUID[],
) => Promise<{ [key: string]: PollWithOptions } | undefined> {
  return useSupabaseCallback(async ({ supabase }, poll_ids) => {
    if (poll_ids.length === 0) return {};

    const { data, error } = await new SupabasePollService(supabase).getPollsWithOptions(poll_ids);

    if (error) {
      console.error("Error fetching poll with options", error);
      throw error;
    }

    return data.reduce<{ [key: string]: PollWithOptions }>((acc, poll) => {
      acc[poll.id] = poll;
      return acc;
    }, {});
  }, []);
}
